import { useEffect } from 'react';

interface PopupBlockedBannerProps {
  show: boolean;
  onClose: () => void;
  duration?: number; // optional auto-hide duration in ms (default 8000)
}

const PopupBlockedBanner: React.FC<PopupBlockedBannerProps> = ({
  show,
  onClose,
  duration = 8000,
}) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [show, onClose, duration]);

  if (!show) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 bg-yellow-100 border-b border-yellow-400 
                 text-yellow-900 px-4 py-3 flex justify-between items-center shadow-md"
      role="alert"
    >
      <span className="flex items-center gap-2">
        <span role="img" aria-label="warning">🚫</span>
        <strong>Popup blocked:</strong>
        <span>Please allow popups for this site to view the PDF.</span>
      </span>

      <button
        onClick={onClose}
        className="ml-4 font-bold text-yellow-900 hover:text-yellow-700 transition-colors"
        aria-label="Dismiss popup warning"
      >
        ✖
      </button>
    </div>
  );
};

export default PopupBlockedBanner;
